export class ConnectRestoreAwsOrganizationalUnitResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "organizationalUnit",
            "baseName": "organizationalUnit",
            "type": "RestoreAwsOrganizationalUnit",
            "format": ""
        },
        {
            "name": "actionApprovalRequest",
            "baseName": "actionApprovalRequest",
            "type": "MPARequest",
            "format": ""
        },
        {
            "name": "mpaPolicies",
            "baseName": "mpaPolicies",
            "type": "MPAPoliciesInfo",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ConnectRestoreAwsOrganizationalUnitResponse.attributeTypeMap;
    }
    constructor() {
    }
}
